export type VideoFilterPreset = 'natural' | 'cinematic' | 'mono' | 'warm';

export interface BuyerRecordedVideoDraft {
  videoFile: File;
  posterFile: File | null;
  createdAt: number;
  source: 'recorder' | 'upload';
  filterPreset: VideoFilterPreset;
  brightness: number;
  contrast: number;
  saturation: number;
  mirrorPreview: boolean;
  includeMicrophone: boolean;
}

let buyerRecordedVideoDraft: BuyerRecordedVideoDraft | null = null;

export const setBuyerRecordedVideoDraft = (draft: BuyerRecordedVideoDraft) => {
  buyerRecordedVideoDraft = draft;
};

export const consumeBuyerRecordedVideoDraft = () => {
  const draft = buyerRecordedVideoDraft;
  buyerRecordedVideoDraft = null;
  return draft;
};
